<div class="cloud-tilebanner">
  <div class="cloud-tilebanner__wrapper" [style.background-image]="parseImagePath(block.data.image_url)">
    <div class="cloud-tilebanner__image">

    </div>
  </div>
</div>
